import React from "react";
import { RouteObject } from "react-router";

// '/signatures/*'
export const SignaturesRoutes: RouteObject[] = [
  {
    path: "sign",
    async lazy() {
      const { SignaturesSign } = await import("customer/Signatures/SignaturesSign");
      return { element: <SignaturesSign /> };
    },
  },
  {
    path: ":id",
    async lazy() {
      const { SignaturesId } = await import("customer/Signatures/SignaturesId");
      return { element: <SignaturesId /> };
    },
  },
];
